import {useState} from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Project} from './project'
import {Button} from './button'
export const Feed = () => {
    const [tabIndex, setTabIndex] = useState(1);
    
    return (
        <div className='userpage_middle'>
            <div className="user_feed mb-3">
                <div className="project-tabs-wrapper">
                    <Tabs
                        className="project-tabs"
                        defaultIndex={tabIndex}
                        selectedIndex={tabIndex}
                        onSelect={(index) => setTabIndex(index)}
                    >
                        <TabList className="project-tab-list">
                            <Tab className="project-tab-item">Featured</Tab>
                            <Tab className="project-tab-item">Last</Tab>
                        </TabList>

                        <TabPanel className="project-tab-panel">

                            <div className="wrapper">
                                <Project images hearted />
                                <Project heart />
                                <Project hearted />
                                <Project />
                                <Project />
                                <Project />

                                <div className="center">
                                    <Button color="bg-blue"> Loading... </Button>
                                </div>
                            </div>

                        </TabPanel>
                        <TabPanel className="project-tab-panel">

                            <Project team heart data={{
                                title: 'We looking Social Media Marketing Freelancer', desc: 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nesciunt iusto magnam praesentium eos'
                            }} />
                            <Project hearted />
                            <Project images />

                        </TabPanel>
                    </Tabs>
                </div>
                
            </div>
        </div>

    )
}